import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import styles from './validDeleteStaffLevelDialog.module.scss'
import { useMutation } from '@apollo/client'
import { Close, Delete } from '@mui/icons-material'
import { DELETE_STAFF_LEVEL } from '@/modules/API/staff/staffLevels'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ValidDeleteGroupProps {
    open: boolean
    handleClose: () => void
    staffLevelId: number
    daycareId: number
    removeOneStaffLevel: (staffLevelId: number) => void
}

const ValidDeleteStaffLevelDialog: FunctionComponent<ValidDeleteGroupProps> = ({
    open,
    handleClose,
    staffLevelId,
    daycareId,
    removeOneStaffLevel
}: ValidDeleteGroupProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteOneStaffLevel] = useMutation(DELETE_STAFF_LEVEL, {
        variables: {
            staffLevelId: staffLevelId,
            daycareId: daycareId
        },
        onCompleted: () => {
            showNotificationSuccess(t('staffLevelDeleted'))

            removeOneStaffLevel(staffLevelId)

            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorDeletedStaffLevel'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('confirmDeleteStaffLevel')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('confirmDeleteStaffLevelMessage')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={deleteOneStaffLevel}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ValidDeleteStaffLevelDialog
